import { IconHome } from '@/components/icons';
import { trans } from '@/i18n';
import { ROUTE_PATH } from '@/routes/paths';
import { FiBook, FiGift, FiUser } from 'react-icons/fi';

export const MENU_LOGOUT = 'logout';

export interface IMenu {
  key: string;
  icon?: React.ReactElement;
  label: string | React.ReactElement;
  children?: IMenu[];
  shortLabel?: string;
}

export const appMenus: IMenu[] = [
  {
    key: 'CLIENT',
    label: trans('menu.client'),
    icon: <IconHome />,
    children: [
      {
        key: ROUTE_PATH.CLIENT,
        label: trans('menu.clientList'),
      },
      {
        key: ROUTE_PATH.CLIENT_CREATE,
        label: trans('menu.createClient'),
      },
    ],
  },
  {
    key: 'ADMIN',
    label: trans('menu.adminAccount'),
    icon: <FiUser />,
    children: [
      {
        key: ROUTE_PATH.ADMIN,
        label: trans('menu.adminAccountList'),
      },
      {
        key: ROUTE_PATH.ADMIN_CREATE,
        label: trans('menu.createAccount'),
      },
    ],
  },
  {
    key: 'PLAN',
    label: trans('menu.plan'),
    icon: <FiGift />,
    children: [
      {
        key: ROUTE_PATH.PLAN,
        label: trans('menu.planList'),
      },
      {
        key: ROUTE_PATH.PLAN_CREATE,
        label: trans('menu.createPlan'),
      },
    ],
  },
  {
    key: 'NOTE',
    label: trans('menu.note'),
    icon: <FiBook />,
    children: [
      {
        key: ROUTE_PATH.NOTE,
        label: trans('menu.noteList'),
      },
      {
        key: ROUTE_PATH.NOTE_ALLARTICLE,
        label: trans('menu.noteArticle'),
      },
    ],
  },
];
